import Modal from "react-bootstrap/Modal";

// Iframe is only rendered while the modal is open, so YouTube's player
// (and its network weight) never loads until the user actually clicks play,
// and playback stops the instant the modal closes instead of continuing
// muted in the background.
const VideoModal = ({ show, onHide, videoId, title = "Vergado product video" }) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Body style={{ position: "relative", padding: 0, background: "#000" }}>
        <button
          onClick={onHide}
          aria-label="Close video"
          style={{
            position: "absolute",
            top: "12px",
            right: "12px",
            zIndex: 10,
            background: "rgba(0,0,0,0.6)",
            border: "none",
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            color: "#fff",
            fontSize: "1.5rem",
            lineHeight: 1,
            cursor: "pointer",
          }}
        >
          &times;
        </button>
        <div style={{ position: "relative", paddingTop: "56.25%" }}>
          {show && (
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`}
              title={title}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default VideoModal;
